import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { EmojiAvatar } from '@factorialco/factorial-one-react/dist/experimental'

interface EmptyStateProps {
  title: string
  description: string
  emoji: string
  buttonText?: string
  buttonAction?: () => void
}

const EmptyState = ({ title, description, emoji, buttonText, buttonAction }: EmptyStateProps) => {
  return (
    <Box alignItems="center" padding="s200">
      <EmojiAvatar emoji={emoji} size="lg" />
      <Box
        maxWidth="s400"
        justifyContent="center"
        padding="s16"
        gap="s16"
        flexGrow
        textAlign="center"
      >
        <Text.Header2>{title}</Text.Header2>
        <Text.Normal size="300" color="grey700">
          {description}
        </Text.Normal>
      </Box>
      {buttonAction && <Button onClick={buttonAction}>{buttonText}</Button>}
    </Box>
  )
}

export default EmptyState
